import ReactDOM from "react-dom";
import { Input, Modal } from "antd";
import React, { useState } from "react";

export const Prompt = ({ title = "", placeholder = "", initialValue = "" }) => {
  return new Promise((resolve, reject) => {
    const div = document.createElement("div");
    document.body.appendChild(div);

    const PromptModal = () => {
      const [inputValue, setInputValue] = useState(initialValue);

      const handleOk = () => {
        const domValue = document.querySelector(".prompt-input").value;
        const value = domValue || initialValue;
        if(!value) {
          return;
        }
        resolve(value);
        cleanup();
      };

      const handleCancel = () => {
        reject();
        cleanup();
      };

      const cleanup = () => {
        ReactDOM.unmountComponentAtNode(div);
        document.body.removeChild(div);
      };

      return (
        <Modal title={title} visible onOk={handleOk} onCancel={handleCancel}>
          <Input
            onKeyDown={(e) => {
              //  enter
              if (e.key === "Enter") {
                handleOk();
              }
            }}
            className="prompt-input"
            placeholder={placeholder}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </Modal>
      );
    };

    ReactDOM.render(<PromptModal />, div);
  });
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/create-project.js